// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"484a814027fbb8273f52","655":"16f2ecd966bef8f00bf7"}[chunkId] + ".js";
};